module.exports = __webpack_public_path__ + "assets/img/31_367_big.47132afa.jpg";